export enum AssignmentsTab {
  Unassigned = "Unassigned",
  Assigned = "Assigned",
  Published = "Published",
}

export enum AssignmentsUnassignedFilter {
  All = "All",
  AssignmentDate = "AssignmentDate",
}

export enum AssignmentsUnassignedDisplayType {
  City = "City",
  Community = "Community",
}

export enum AssignmentsUnassignedDisplayMode {
  All = "All",
  One = "One",
  Two = "Two",
}

export enum AssignmentUserSortBy {
  Alphabetical = "Alphabetical",
  OrdersCount = "OrdersCountASC",
  OrdersCountDesc = "OrdersCountDESC",
}

export enum AssignmentsPageView {
  Calendar = "Calendar",
  Map = "Map",
}

export const ASSIGNMENTS_CALENDAR_NO_ORDERS_MESSAGE = "No Orders";

export const ASSIGNMENTS_CALENDAR_NO_ASSIGNMENTS_MESSAGE = "No Assignments";

export const ASSIGNMENTS_ALL_OPTION = "All";

export const ASSIGNMENTS_ONE_DISPLAY_MODE_WIDTH = 105;

export const ASSIGNMENTS_TWO_DISPLAY_MODE_WIDTH = 300;

export const DEFAULT_ASSIGNMENTS_COLUMN_WIDTH = 195;

export const DEFAULT_ASSIGNMENTS_CARD_SCROLL_AMOUNT = 199;

export const ASSIGNMENTS_NUMBER_OF_CONTAINERS_PER_PAGE = 2;

export const ASSIGNMENTS_CONTAINER_HEIGHT_OFFSET = 290;

export const assignmentsTabGroups = {
  Unassigned: {
    label: "Unassigned Orders",
    value: AssignmentsTab.Unassigned,
  },
  Assigned: {
    label: "Assigned Orders",
    value: AssignmentsTab.Assigned,
  },
  Published: {
    label: "Published Orders",
    value: AssignmentsTab.Published,
  },
};

export const UNASSIGNED_DISPLAY_OPTIONS = [
  {
    label: "City",
    value: AssignmentsUnassignedDisplayType.City,
    sx: {
      minWidth: "41px",
    },
  },
  {
    label: "Community",
    value: AssignmentsUnassignedDisplayType.Community,
    sx: {
      minWidth: "76px",
    },
  },
] as const;

export const UNASSIGNED_CITY_DISPLAY_OPTIONS = [
  {
    label: "All Cities",
    value: AssignmentsUnassignedDisplayMode.All,
    sx: {
      minWidth: "105px",
    },
  },
  {
    label: "One City",
    value: AssignmentsUnassignedDisplayMode.One,
    sx: {
      minWidth: "105px",
    },
  },
  {
    label: "Two Cities",
    value: AssignmentsUnassignedDisplayMode.Two,
    sx: {
      minWidth: "115px",
    },
  },
] as const;

export const UNASSIGNED_COMMUNITY_DISPLAY_OPTIONS = [
  {
    label: "All Communities",
    value: AssignmentsUnassignedDisplayMode.All,
    sx: {
      minWidth: "105px",
    },
  },
  {
    label: "One Community",
    value: AssignmentsUnassignedDisplayMode.One,
    sx: {
      minWidth: "105px",
    },
  },
  {
    label: "Two Communities",
    value: AssignmentsUnassignedDisplayMode.Two,
    sx: {
      minWidth: "115px",
    },
  },
] as const;
